import { render, staticRenderFns } from "./FeeSelector.vue?vue&type=template&id=1d47f3fe&scoped=true&"
import script from "./FeeSelector.vue?vue&type=script&lang=ts&"
export * from "./FeeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FeeSelector.vue?vue&type=style&index=0&id=1d47f3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47f3fe",
  null
  
)

export default component.exports